import { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { Menu, MenuButton, MenuList, Box } from '@chakra-ui/react'
import { ChevronDown as ChevronDownIcon } from 'icon'
import { DEFAULT_COUNTRY_PHONE } from 'config/defaultCountry'
import { FixedSizeList as List } from 'react-window'

import store from 'stores'
import { CountryItem } from './CountryItem'

export const InternationalPhone = ({
  onChange,
  defaultCountry = DEFAULT_COUNTRY_PHONE,
}) => {
  const [selectedCountry, setSelectedCountry] = useState(defaultCountry)
  const [countryList, setCountryList] = useState([])
  const [indexCountry, setIndexCountry] = useState(0)
  const [isOpen, setIsOpen] = useState(false)

  const countryListRef = useRef(null)
  const listRef = useRef(null)
  const getData = useCallback(async () => {
    const { list, defaultCountryIndex } = await store.country.getCountry(
      defaultCountry
    )

    setCountryList(list)
    setIndexCountry(defaultCountryIndex)
  }, [defaultCountry])

  useEffect(() => {
    getData()
  }, [getData])

  const handleItemClick = useCallback(
    (country) => {
      setSelectedCountry(country)
      onChange?.(country)
    },
    [onChange]
  )

  const handleMenuOpen = () => {
    setIsOpen(true)
  }

  useEffect(() => {
    if (countryList.length > 0 && indexCountry && countryListRef.current) {
      setSelectedCountry(countryList[indexCountry])
    }
  }, [countryList, indexCountry])

  useEffect(() => {
    if (isOpen && listRef.current) {
      listRef.current.scrollToItem(indexCountry, 'center')
    }
  }, [isOpen, indexCountry])

  const renderCountryItem = ({ index, style }) => {
    const { id, countryName, flagIcon, phoneCode } = countryList[index]

    return (
      <div style={style} key={id}>
        <CountryItem
          onClick={() => handleItemClick(countryList[index])}
          isActive={selectedCountry.countryName === countryName}
          data={{
            flagIcon,
            countryName,
            phoneCode,
          }}
        />
      </div>
    )
  }

  return (
    <Box display="flex">
      <Menu>
        <MenuButton
          data-testid="countries-menu-button"
          background="none"
          display="flex"
          onClick={handleMenuOpen}
        >
          <Box display="flex" gap={3} paddingLeft="28px" alignItems="center">
            <Box height="33px" fontSize={25}>
              {selectedCountry.flagIcon}
            </Box>
            <ChevronDownIcon />
          </Box>
        </MenuButton>
        <MenuList
          maxHeight="250px"
          overflowY="auto"
          boxShadow="0 2px 4px rgba(0, 0, 0, 0.1)"
          padding={0}
          border="none"
          data-testid="countries-list"
          ref={countryListRef}
        >
          <List
            ref={listRef}
            height={250}
            itemCount={countryList.length}
            itemSize={50}
            width="100%"
          >
            {renderCountryItem}
          </List>
        </MenuList>
      </Menu>
      <Box
        data-testid="international-selected-code"
        fontWeight="500"
        fontSize="16px"
        borderLeft="1px solid #c3cad4"
        margin="6px 10px"
        paddingLeft="12px"
        lineHeight="30px"
      >
        ({selectedCountry.phoneCode})
      </Box>
    </Box>
  )
}

export default InternationalPhone
